module.exports = __webpack_public_path__ + "assets/img/BY.4a3c38ab.png";